<template>
  <MetricTimeSeries
    :title="title"
    :item-id="itemId"
    :metric="metric"
    v-bind="$attrs"
  />
</template>

<script>
import MetricTimeSeries from '@/components/cards/MetricTimeSeries';
import { POST_FIELDS } from '@/services/charts-service';

export default {
  name: 'InteractionsInTimeChart',
  components: {
    MetricTimeSeries,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    metric() {
      return POST_FIELDS.INTERACTIONS;
    },
  },
};
</script>
